<template>
  <div>
    <b-tabs
      pills
      :vertical="$store.getters['app/currentBreakPoint'] === 'xs'"
      content-class="col-12 px-sm-0"
      nav-wrapper-class="col-12 px-sm-0"
      nav-class="nav-left mb-sm-2"
    >
      <b-tab v-for="tab in tabs" :key="tab.key" :title="tab.name" lazy>
        <table-dynamic-server-side-v2 :key-name="tab.key" :url="tab.url" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    TableDynamicServerSideV2: () => import('./components/TableDynamicServerSideV2.vue'),
  },
  data() {
    return {
      tabs: [
        {
          key: 'all',
          name: 'ทั้งหมด',
          total: 0,
          url: '/api/admin/partners/index',
        },
        {
          key: 'pending',
          name: 'รออนุมัติ',
          total: 0,
          url: '/api/admin/partners/index?f_status=Submit',
        },
        {
          key: 'create-document-contract',
          name: 'รอครีเอเตอร์เซ็นเอกสารสัญญา',
          total: 0,
          url: '/api/admin/partners/index?f_status=CreateDocumentContract',
        },
        {
          key: 'pending-document-contract',
          name: 'รอแอดมินอนุมัติเอกสารสัญญา',
          total: 0,
          url: '/api/admin/partners/index?f_status=PendingDocumentContract',
        },
        {
          key: 'approve',
          name: 'อนุมัติ',
          total: 0,
          url: '/api/admin/partners/index?f_status=Approval',
        },
        {
          key: 'reject',
          name: 'ไม่อนุมัติ',
          total: 0,
          url: '/api/admin/partners/index?f_status=Reject',
        },
      ],
    }
  },
  methods: {
    updateTabsTotal() {
      // console.log('updateTabsTotal')
    },
  },
}
</script>

<style lang="scss" scoped></style>
